import { SxProps } from "@mui/system";
import colors from "../../theme/Colours";

export const containerStyle: SxProps = {
  borderRadius: "4px",
  backgroundColor: colors.background2,
  border: `1px solid ${colors.ledgerCustomerPaginationBox}`,
};

export const searchAndSortContainer: SxProps = {
  alignItems: "center",
  justifyContent: "space-between",
  width: "100%",
  gap: 2,
  display: "flex",
  flexDirection: "row",
  flexWrap: "wrap",
  marginBottom: "20px",
};

export const sortByContainer: SxProps = {
  display: "flex",
  flexDirection: "row",
  justifyContent: "flex-end",
  alignItems: "flex-end",
  backgroundColor: colors.background2,
  borderRadius: "8px",
  height: "40px",
  boxShadow: "none",
  "& .MuiOutlinedInput-notchedOutline": {
    border: `1px solid ${colors.searchInputBorder} !important`,
  },
};

export const dropdownContainer: SxProps = {
  display: "flex",
  flexDirection: "row",
  gap: 2,
};

export const buttonStyle: SxProps = {
  height: "40px",
  width: "120px",
  borderRadius: "4px",
  backgroundColor: colors.primaryButtonOrange,
  color: colors.background2,
  boxShadow: "none",
  border: "none",
  "&:hover": {
    backgroundColor: colors.primaryButtonOrangeHover,
    boxShadow: "none",
  },
  "&.Mui-disabled": {
    border: "none",
    backgroundColor: colors.primaryButtonOrangeDisabled,
    color: colors.background2,
  },
};

export const sortByLabelStyle: SxProps = {
  marginRight: -1.1,
  color: "gray",
  fontSize: "12px",
  fontFamily: "Poppins, sans-serif",
  marginLeft: 0.5,
};

export const sortBySelectStyle: SxProps = {
  width: "200px",
  height: "100%",
  fontWeight: 400,
  backgroundColor: "transparent",
  fontSize: "13px",
  fontFamily: "Poppins, sans-serif",
  "& .MuiOutlinedInput-notchedOutline": {
    border: "none",
  },
};

export const mainContentStyle: SxProps = {
  minHeight: "553px",
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
};

export const paginationContainerStyle: SxProps = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  marginTop: "12px",
  backgroundColor: colors.background2,
  padding: "12px 24px",
  border: `1px solid ${colors.ledgerCustomerPaginationBox}`,
};

export const paginationCaptionStyle: SxProps = {
  color: colors.paginationCaption,
  fontFamily: "Poppins, sans-serif",
  fontWeight: 500,
};

export const customerNameStyle: SxProps = {
  color: "#333",
  cursor: "pointer",
  fontFamily: "Poppins, sans-serif",
  fontSize: "14px",
};
